module.exports = __webpack_public_path__ + "static/media/04.eb915940.jpg";